import { createReducer } from '@reduxjs/toolkit';
import type { AlertModalOptions } from '../actions/alert-modal';
import { CLOSE_ALERT_MODAL, OPEN_ALERT_MODAL } from '../actions/alert-modal';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const nothingToDo = () => {};

type AlertModalState = {
  isModalOpen: boolean;
} & AlertModalOptions;

const initState: AlertModalState = {
  isModalOpen: false,
  body: undefined,
  useCancel: true,
  styles: {},
  confirmText: 'OK',
  cancelText: 'キャンセル',
  confirmColor: 'normal',
  cancelColor: 'gray',
  onConfirm: nothingToDo,
  onCancel: nothingToDo,
};

const alertModalReducer = createReducer(initState, (builder) =>
  builder
    .addCase(OPEN_ALERT_MODAL, (_, action) => {
      return { isModalOpen: true, ...action.payload };
    })
    .addCase(CLOSE_ALERT_MODAL, (state, action) => {
      return { ...state, isModalOpen: false, ...action.payload };
    })
);

export default alertModalReducer;
